import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import type { TeamBasicDTO } from '@bb/domain/dist/types';

import errorReporter from '@app/errorReporter';
import { AuthContext, TeamContext } from 'contexts';
import { message } from 'components';

const useTeam = () => {
  const { auth } = useContext(AuthContext);
  const { targetTeamId, availableTeamStates } = useContext(TeamContext);
  const [isLoading, setIsLoading] = useState(false);
  const [teamUsers, setTeamUsers] = useState<TeamBasicDTO>([]);

  useEffect(() => {
    // Only fetch if we have a valid targetTeamId
    if (!auth || !targetTeamId) {
      setTeamUsers([]);
      return;
    }

    setIsLoading(true);
    (async () => {
      try {
        const { data } = await axios.get<TeamBasicDTO>(
          `/user/team/basic/${targetTeamId}`,
        );

        setTeamUsers(data);
      } catch (err) {
        errorReporter.error(err);
        message.error('Error loading team');
      } finally {
        setIsLoading(false);
      }
    })();
  }, [auth, targetTeamId]);

  return { targetTeamId, availableTeamStates, teamUsers, isLoading };
};

export default useTeam;
